module.exports = __webpack_public_path__ + "static/media/shutterstock_653970169.ea5d8c7b.jpg";